var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.info.sourceType === 'PGM' ? _vm.$t('audioChannels.audioSetting') : _vm.$t('audioChannels.rvt'),
      "visible": _vm.info.show,
      "top": "70px",
      "close-on-click-modal": false,
      "append-to-body": _vm.appendToBody,
      "width": "500px"
    },
    on: {
      "update:visible": function ($event) {
        return _vm.$set(_vm.info, "show", $event);
      },
      "close": _vm.cancel
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "content",
    attrs: {
      "element-loading-text": "",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0)"
    }
  }, [_c('div', {
    staticClass: "vfb"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.info.sourceType === 'PGM' ? _vm.$t('common.slotSelection') : _vm.$t('common.typeSelection')))]), _vm.enableList.length ? _c('div', {
    staticClass: "btns clearfix"
  }, _vm._l(_vm.enableList, function (val, key) {
    return _c('div', {
      key: key,
      class: _vm.returnClass(val),
      attrs: {
        "title": val
      }
    }, [_c('el-radio', {
      staticClass: "common",
      attrs: {
        "label": val
      },
      on: {
        "click": function ($event) {
          return _vm.select(val);
        }
      },
      model: {
        value: _vm.selectSource,
        callback: function ($$v) {
          _vm.selectSource = $$v;
        },
        expression: "selectSource"
      }
    }, [_vm._v(" " + _vm._s(_vm.returnLabel(val)) + " "), val === 'PGM (mix minus)' ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": _vm.mixMinusContent,
        "placement": "top-start"
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_vm._v(_vm._s(_vm.$t('common.mixMinusOn'))), _c('br'), _vm._v(_vm._s(_vm.$t('common.mixMinusOff')))]), _c('i', {
      staticClass: "iconfont icon-help2"
    })]) : _vm._e()], 1)], 1);
  }), 0) : _vm._e(), _c('el-divider', {
    staticClass: "contentDivider"
  }), !_vm.loading && !_vm.enableList.length && _vm.info.sourceType != 'PGM' ? _c('div', {
    staticClass: "defaultText"
  }, [_vm._v(_vm._s(_vm.$t('common.noData')))]) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.enableList.length || _vm.info.sourceType === 'PGM',
      expression: "enableList.length||info.sourceType === 'PGM'"
    }],
    staticClass: "switch clearfix"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t('audioChannels.audioChannels')))])]), _c('div', {
    staticClass: "audio"
  }, [_vm.audioType == 0 ? _c('div', {
    staticClass: "channel"
  }, [_vm.info.sourceType === 'PGM' ? _c('el-radio-group', {
    staticClass: "audioPair",
    model: {
      value: _vm.channelCount,
      callback: function ($$v) {
        _vm.channelCount = $$v;
      },
      expression: "channelCount"
    }
  }, _vm._l(_vm.audioChannelByType[_vm.selectSource], function (val) {
    return _c('el-radio', {
      key: val,
      staticClass: "common",
      attrs: {
        "label": val
      }
    }, [_vm._v(_vm._s(_vm.$t('audioChannels.stereo')) + " " + _vm._s(val))]);
  }), 1) : _c('el-radio-group', {
    staticClass: "audioPair",
    model: {
      value: _vm.channelCount,
      callback: function ($$v) {
        _vm.channelCount = $$v;
      },
      expression: "channelCount"
    }
  }, _vm._l(_vm.audioChannelByType[_vm.selectSource], function (val) {
    return _c('el-radio', {
      key: val,
      staticClass: "common",
      attrs: {
        "label": val
      }
    }, [_vm._v(_vm._s(_vm.$t('audioChannels.stereo')) + " " + _vm._s(val))]);
  }), 1)], 1) : _vm._e()]), _c('div', {
    staticClass: "btn"
  }, [_vm.enableList.length || _vm.info.sourceType == 'PGM' ? _c('div', [_c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('audioChannels.cancel')) + " ")]), _c('el-button', {
    class: {
      red: _vm.returnStatus
    },
    attrs: {
      "type": "primary",
      "disabled": !_vm.selectSource
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" " + _vm._s(_vm.returnStatus ? _vm.$t('audioChannels.stop') : _vm.$t('audioChannels.send')) + " "), _vm.loadingBtn && _vm.clickType == 'vfb' ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()])], 1) : !_vm.enableList.length ? _c('el-button', {
    staticStyle: {
      "color": "#fff !important"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" " + _vm._s(_vm.returnStatus ? _vm.$t('audioChannels.stop') : _vm.$t('audioChannels.gotIt')) + " ")]) : _vm._e()], 1)], 1)])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };